import {
  useGetDepositStatementQuery,
  useLazyDownloadDepositStatementQuery,
} from "@/modules/deposit/services";
import { DownloadExtension } from "@/shared/common/constants";
import { DownloadType } from "@/shared/common/enums";
import type { IError } from "@/shared/common/types";
import { FilterPanel, Statement } from "@/shared/components";
import { useFilters } from "@/shared/hooks";
import { downloadFileFromUrl } from "@/shared/utils";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export const DepositStatement = () => {
  const { t } = useTranslation();
  const { depositId = "" } = useParams();
  const { filters, setFilters, defaultFilters } = useFilters();

  const [
    downloadDepositStatement,
    { isFetching: isDownloading },
  ] = useLazyDownloadDepositStatementQuery();

  const {
    data: depositStatement,
    isFetching,
    isError,
    error,
    refetch,
  } = useGetDepositStatementQuery({
    id: depositId,
    ...filters,
  }, {
    refetchOnMountOrArgChange: true,
  });

  const onDownload = (exportFormat: DownloadType) => {
    downloadDepositStatement({
      id: depositId,
      exportFormat,
      ...filters,
    })
      .unwrap()
      .then((response) => {
        if (response?.url) {
          const fileType = DownloadExtension[exportFormat];
          const name = `Deposit-statements-${filters.startDate}-${filters.endDate}.${fileType}`;
          downloadFileFromUrl(response.url, name);
        }
      });
  };

  const actions = [
    {
      label: t("general.pdf"),
      type: DownloadType.Pdf,
    }
  ];

  return (
    <Statement
      onDownload={onDownload}
      isFetching={isFetching}
      isError={isError}
      actions={actions}
      isDownloading={isDownloading}
      error={error as IError}
      refetch={refetch}
      statement={depositStatement}
    >
      <FilterPanel
        filters={filters}
        setFilters={setFilters}
        defaultFilters={defaultFilters}
      />
    </Statement>
  );
};
